import renderMobxRestApp from 'render_mobx_rest_app' // must always come first!

import { loadStripe } from '@stripe/stripe-js'
import { Route, Router, Switch } from 'react-router-dom'

import { JoinPTALayout } from 'applets/join_pta/layout'
import 'applets/join_pta/join_pta_styles.scss'

import '../hmr'

export const stripePromise = loadStripe(window['STRIPE_PUBLIC_KEY'])

const JoinPTALayoutWithRouter = (props) => (
  <Router history={props.history}>
    <Switch>
      <Route component={JoinPTALayout} />
    </Switch>
  </Router>
)

renderMobxRestApp({
  RootComponent: JoinPTALayoutWithRouter,
  basename: window['BASE_PATH'],
  stripePromise,
})
